import { getValueInRange } from './math'; // getCurrentPageIndexByCurrentParticleIndex

export function _getCurrentPageIndexByCurrentParticleIndexInfinite(_ref) {
  var currentParticleIndex = _ref.currentParticleIndex,
      particlesCount = _ref.particlesCount,
      clonesCountHead = _ref.clonesCountHead,
      clonesCountTotal = _ref.clonesCountTotal,
      particlesToScroll = _ref.particlesToScroll;
  if (currentParticleIndex === particlesCount - clonesCountHead) return 0;
  if (currentParticleIndex === 0) return _getPagesCountByParticlesCountInfinite({
    particlesCountWithoutClones: particlesCount - clonesCountTotal,
    particlesToScroll: particlesToScroll
  }) - 1;
  return Math.floor((currentParticleIndex - clonesCountHead) / particlesToScroll);
}
export function _getCurrentPageIndexByCurrentParticleIndexLimited(_ref2) {
  var currentParticleIndex = _ref2.currentParticleIndex,
      particlesToScroll = _ref2.particlesToScroll;
  return Math.ceil(currentParticleIndex / particlesToScroll);
}
export function getCurrentPageIndexByCurrentParticleIndex(_ref3) {
  var currentParticleIndex = _ref3.currentParticleIndex,
      particlesCount = _ref3.particlesCount,
      clonesCountHead = _ref3.clonesCountHead,
      clonesCountTotal = _ref3.clonesCountTotal,
      infinite = _ref3.infinite,
      particlesToScroll = _ref3.particlesToScroll;
  return infinite ? _getCurrentPageIndexByCurrentParticleIndexInfinite({
    currentParticleIndex: currentParticleIndex,
    particlesCount: particlesCount,
    clonesCountHead: clonesCountHead,
    clonesCountTotal: clonesCountTotal,
    particlesToScroll: particlesToScroll
  }) : _getCurrentPageIndexByCurrentParticleIndexLimited({
    currentParticleIndex: currentParticleIndex,
    particlesToScroll: particlesToScroll
  });
} // getPagesCountByParticlesCount

export function _getPagesCountByParticlesCountInfinite(_ref4) {
  var particlesCountWithoutClones = _ref4.particlesCountWithoutClones,
      particlesToScroll = _ref4.particlesToScroll;
  return Math.ceil(particlesCountWithoutClones / particlesToScroll);
}
export function _getPagesCountByParticlesCountLimited(_ref5) {
  var particlesCountWithoutClones = _ref5.particlesCountWithoutClones,
      particlesToScroll = _ref5.particlesToScroll,
      particlesToShow = _ref5.particlesToShow;
  var partialPageSize = getPartialPageSize({
    particlesCountWithoutClones: particlesCountWithoutClones,
    particlesToScroll: particlesToScroll,
    particlesToShow: particlesToShow
  });
  return Math.ceil(particlesCountWithoutClones / particlesToScroll) - partialPageSize;
}
export function getPagesCountByParticlesCount(_ref6) {
  var infinite = _ref6.infinite,
      particlesCountWithoutClones = _ref6.particlesCountWithoutClones,
      particlesToScroll = _ref6.particlesToScroll,
      particlesToShow = _ref6.particlesToShow;
  return infinite ? _getPagesCountByParticlesCountInfinite({
    particlesCountWithoutClones: particlesCountWithoutClones,
    particlesToScroll: particlesToScroll
  }) : _getPagesCountByParticlesCountLimited({
    particlesCountWithoutClones: particlesCountWithoutClones,
    particlesToScroll: particlesToScroll,
    particlesToShow: particlesToShow
  });
} // getParticleIndexByPageIndex

export function _getParticleIndexByPageIndexInfinite(_ref7) {
  var pageIndex = _ref7.pageIndex,
      clonesCountHead = _ref7.clonesCountHead,
      clonesCountTail = _ref7.clonesCountTail,
      particlesToScroll = _ref7.particlesToScroll,
      particlesCount = _ref7.particlesCount;
  return getValueInRange(0, Math.min(clonesCountHead + pageIndex * particlesToScroll, particlesCount - clonesCountTail), particlesCount - 1);
}
export function _getParticleIndexByPageIndexLimited(_ref8) {
  var pageIndex = _ref8.pageIndex,
      particlesToScroll = _ref8.particlesToScroll,
      particlesCount = _ref8.particlesCount,
      particlesToShow = _ref8.particlesToShow;
  return getValueInRange(0, Math.min(pageIndex * particlesToScroll, particlesCount - particlesToShow), particlesCount - 1);
}
export function getParticleIndexByPageIndex(_ref9) {
  var infinite = _ref9.infinite,
      pageIndex = _ref9.pageIndex,
      clonesCountHead = _ref9.clonesCountHead,
      clonesCountTail = _ref9.clonesCountTail,
      particlesToScroll = _ref9.particlesToScroll,
      particlesCount = _ref9.particlesCount,
      particlesToShow = _ref9.particlesToShow;
  return infinite ? _getParticleIndexByPageIndexInfinite({
    pageIndex: pageIndex,
    clonesCountHead: clonesCountHead,
    clonesCountTail: clonesCountTail,
    particlesToScroll: particlesToScroll,
    particlesCount: particlesCount
  }) : _getParticleIndexByPageIndexLimited({
    pageIndex: pageIndex,
    particlesToScroll: particlesToScroll,
    particlesCount: particlesCount,
    particlesToShow: particlesToShow
  });
}
export function applyParticleSizes(_ref10) {
  var particlesContainerChildren = _ref10.particlesContainerChildren,
      particleWidth = _ref10.particleWidth;

  for (var particleIndex = 0; particleIndex < particlesContainerChildren.length; particleIndex++) {
    particlesContainerChildren[particleIndex].style.minWidth = "".concat(particleWidth, "px");
    particlesContainerChildren[particleIndex].style.maxWidth = "".concat(particleWidth, "px");
  }
}
export function getPartialPageSize(_ref11) {
  var particlesToScroll = _ref11.particlesToScroll,
      particlesToShow = _ref11.particlesToShow,
      particlesCountWithoutClones = _ref11.particlesCountWithoutClones;
  var overlap = particlesToScroll - particlesToShow;
  var particlesCount = particlesToShow;

  while (true) {
    var diff = particlesCountWithoutClones - particlesCount - overlap;

    if (diff < particlesToShow) {
      return Math.max(diff, 0); // show: 2; scroll: 3, n: 5 => -1
    }

    particlesCount += particlesToShow + overlap;
  }
}
export function createResizeObserver(onResize) {
  return new ResizeObserver(function (entries) {
    onResize({
      width: entries[0].contentRect.width
    });
  });
}